import React, { useState, useEffect, } from 'react';
import api from './api';
import { MdLogin, MdLogout, MdFreeBreakfast } from 'react-icons/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './attendance.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useMemo } from 'react';


const AttendanceForm = () => {
  const token = localStorage.getItem('employeeToken');
  const [pendingRequests, setPendingRequests] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loggedEmployee, setLoggedEmployee] = useState(null);
  const [attendanceList, setAttendanceList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hrCurrentPage, setHrCurrentPage] = useState(1);

  const [showRegularizeForm, setShowRegularizeForm] = useState(false);
  const [selectedDateForCorrection, setSelectedDateForCorrection] = useState(null);
  const [manualCheckIn, setManualCheckIn] = useState('');
  const [manualCheckOut, setManualCheckOut] = useState('');
  const [reason, setReason] = useState('');
  const [calendarHolidays, setCalendarHolidays] = useState([]);
  const [publicHolidays, setPublicHolidays] = useState([]);

  const [leaveList, setLeaveList] = useState([]);
  const [fetchedMonths, setFetchedMonths] = useState(new Set());
  const [showLeaveForm, setShowLeaveForm] = useState(false);
  const [selectedDateForLeave, setSelectedDateForLeave] = useState(null);
  const [leaveType, setLeaveType] = useState('full'); // 'full' or 'half'
  const [halfDayType, setHalfDayType] = useState('morning'); // 'morning' or 'afternoon'
  const [leaveReason, setLeaveReason] = useState('');
  const [summary, setSummary] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const [showHolidayForm, setShowHolidayForm] = useState(false);
  // const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [calendarKey, setCalendarKey] = useState(0);
  const employeeData = JSON.parse(localStorage.getItem('employee'));
  const initialRole = employeeData?.role || "";
  const [role, setRole] = useState(initialRole);
  const isHR = role.trim().toLowerCase() === "hr";
  const [monthlyData, setMonthlyData] = useState({
    days: {},
    summary: null
  });
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const [showWorkRequestModal, setShowWorkRequestModal] = useState(false);
  const [selectedWorkDate, setSelectedWorkDate] = useState(null);
  const [selectedWorkType, setSelectedWorkType] = useState('full');
  const [pendingWorkRequests, setPendingWorkRequests] = useState([]);

  const recordsPerPage = 8;
  const hrRecordsPerPage = 10;
  //const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  console.log("🛡️ Token being sent:", token);


  //  HR fetch function
  const fetchAllAttendanceForHR = async () => {
    try {
      const res = await api.get('/attendance');
      console.log(" HR All Attendance:", res.data);
      setAttendanceList(res.data);
    } catch (err) {
      console.error(" HR Attendance Error:", err);
      toast.error('Failed to fetch all employees attendance');
    }
  };

  const fetchPendingRequests = async () => {
    try {
      const res = await api.get('/attendance/regularization-requests');
      console.log("Pending requests for HR:", res.data);
      setPendingRequests(res.data);
    } catch (err) {
      console.error("Failed to fetch HR requests:", err.response?.data);
      toast.error('Failed to load HR requests');
    }
  };

  const fetchMonthlyLeaves = async (employeeId, month, year) => {
    const key = `${employeeId}-${month}-${year}`;
    if (fetchedMonths.has(key)) return;

    try {
      const res = await api.get('/employee-leaves', {
        params: { employee_id: employeeId, month, year },
      });

      if (Array.isArray(res.data)) {
        // Remove duplicate leaves from the response (if any)
        const uniqueNewLeaves = res.data.filter((leave, index, self) =>
          index === self.findIndex((t) => (
            t.id === leave.id &&
            t.start_date === leave.start_date &&
            t.end_date === leave.end_date
          ))
        );

        console.log("Unique new leaves from API:", uniqueNewLeaves);

        setLeaveList(prev => {
          // Filter out leaves that are already in state
          const filteredNewLeaves = uniqueNewLeaves.filter(newLeave =>
            !prev.some(existingLeave => existingLeave.id === newLeave.id)
          );

          console.log("Leaves to add after filtering existing:", filteredNewLeaves);

          return [
            ...prev,
            ...filteredNewLeaves.map(l => ({
              ...l,
              start_date: normalizeDate(l.start_date), // Using normalizeDate instead of split
              end_date: normalizeDate(l.end_date)
            }))
          ];
        });

        setFetchedMonths(prev => new Set([...prev, key])); // More immutable way
        return res.data;
      }
    } catch (error) {
      console.error('Failed to fetch leaves:', error);
      // Consider adding error handling/notification here
      throw error; // Re-throw if you want calling code to handle it
    }
  };

  const getLeaveStatusForDate = (dateStr) => {
    if (!selectedEmployee) {
      console.error('No selected employee');
      return null;
    }

    console.log('Checking leaves for employee:', selectedEmployee.id);

    const matchingLeaves = leaveList.filter(l => {
      if (l.employee_id !== selectedEmployee.id) {
        console.log(`Skipping leave ${l.id} - wrong employee (${l.employee_id} != ${selectedEmployee.id})`);
        return false;
      }

      if (!l.start_date || !l.end_date) {
        console.log(`Skipping leave ${l.id} - missing dates`);
        return false;
      }

      const start = normalizeDate(l.start_date);
      const end = normalizeDate(l.end_date);
      const current = normalizeDate(dateStr);

      const isMatch = current >= start && current <= end;
      console.log(`Leave ${l.id} (${start} to ${end}) matches ${current}:`, isMatch);
      return isMatch;
    });

    console.log('Total matching leaves:', matchingLeaves.length);

    if (matchingLeaves.length === 0) return null;

    return matchingLeaves[0].status === 'approved' ? 'leave_approved' : 'leave_applied';
  };

  // calender  leave code
  const submitLeaveRequest = async () => {
    if (!selectedEmployee || !selectedDateForLeave) return;

    try {
      const date = selectedDateForLeave;

      const data = {
        employee_id: selectedEmployee.id,
        name: selectedEmployee.name,
        reason: leaveReason,
        start_date: date,
        end_date: date,
        type: leaveType, // 'full' or 'half'
        half_day_type: leaveType === 'half' ? halfDayType : null,
      };

      await api.post('/leaves', data);

      toast.success('Leave applied successfully!');
      setShowLeaveForm(false);
      setLeaveReason('');
      setLeaveType('full');
      setHalfDayType('morning');

      const today = new Date();
      await fetchMonthlyLeaves(selectedEmployee.id, today.getMonth() + 1, today.getFullYear());
    } catch (error) {
      toast.error('Something went wrong while applying.');
      console.error("Leave apply error:", error);
    }
  };


  const fetchAttendanceByRange = async (empId, from, to) => {
    try {
      const res = await api.get(`/employee/attendance/${empId}/range`, {
        params: { from, to },
      });
      console.log(" Attendance List:", res.data);
      setAttendanceList(res.data);  //display dots in calender
      return { data: res.data };
    } catch (error) {
      toast.error("Failed to fetch attendance by date range.");
      return { data: [] };
    }
  };

  useEffect(() => {
    if (!token) return;

    const fetchCurrentEmployee = async () => {
      setLoading(true);
      try {
        const res = await api.get('/me');
        setRole(res.data.role || "");
        if (res.data.role?.toLowerCase() === 'hr') {
          await fetchAllAttendanceForHR();
          await fetchPendingRequests();
        } else {
          setSelectedEmployee(res.data);
          const today = new Date();
          const from = new Date(today.getFullYear(), today.getMonth() - 6, 1).toISOString().split("T")[0];
          const to = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split("T")[0];
          await fetchAttendanceByRange(res.data.id, from, to);
        }
      } catch (err) {
        toast.error('Failed to fetch logged-in employee');
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentEmployee();
  }, [token]);


  useEffect(() => {
    const today = new Date();
    fetchHolidaysForMonth(today.getMonth() + 1, today.getFullYear());
  }, []);


  const punchIn = async () => {
    const now = new Date();
    const tenAM = new Date();
    tenAM.setHours(10, 0, 0, 0);

    if (now < tenAM) toast.info('You are logging in early!');

    try {
      const response = await api.post('/attendance/punch-in', {
        employee_id: selectedEmployee.id
      });

      console.log("PunchIn API Response:", response.data);

      // Holiday / Weekly Off (no approved request)
      if (response.data.status === 'holiday' || response.data.status === 'weekly_off') {
        toast.info(response.data.message);
        return;
      }

      // Attendance data (present / extra work)
      if (response.data?.data) {
        const data = response.data.data;

        setAttendanceList(prev => {
          const existingIndex = prev.findIndex(a =>
            a.employee_id === selectedEmployee.id &&
            a.date === todayStr
          );

          if (existingIndex >= 0) {
            const updated = [...prev];
            updated[existingIndex] = { ...updated[existingIndex], ...data };
            return updated;
          } else {
            return [...prev, { ...data, employee_id: selectedEmployee.id, date: todayStr }];
          }
        });

        if (data.status === 'extra_work') {
          toast.info('Extra work day logged!');
        }
      }

      toast.success(response.data?.message || 'Punch in successful!');

      // Optional: Refresh attendance list
      const currentDate = new Date();
      const from = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        .toISOString().split("T")[0];
      const to = new Date().toISOString().split("T")[0];
      await fetchAttendanceByRange(selectedEmployee.id, from, to);

    } catch (err) {
      console.error("PunchIn Error Details:", {
        status: err.response?.status,
        data: err.response?.data,
        message: err.message
      });

      const errorMessage = err.response?.data?.message ||
        (err.response?.status === 400 ? 'Already punched in today' : 'Punch in failed');
      toast.error(errorMessage);
    }
  };

  //reuest aplied to work on holiday /weekoff

  const submitWorkRequest = async () => {
    try {
      const response = await api.post('/work-on-holiday', {
        employee_id: selectedEmployee.id,
        date: selectedWorkDate,
        work_type: selectedWorkType
      });

      toast.success(response.data.message);
      setShowWorkRequestModal(false);
      // Optionally, refresh pending requests for HR view
      fetchPendingWorkRequests();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Request failed');
    }
  };

  const fetchPendingWorkRequests = async () => {
    try {
      const res = await api.get('/work-on-holiday/pending');
      console.log("Pending work requests from backend:", res.data); //  Debug
      setPendingWorkRequests(res.data);
    } catch (err) {
      toast.error('Failed to fetch pending work requests');
    }
  };

  useEffect(() => {
    if (isHR) fetchPendingWorkRequests();
  }, []);

  const updateRequestStatus = async (requestId, status) => {
    try {
      const res = await api.post(`/work-on-holiday/${requestId}/approve`, { status });
      toast.success(res.data.message);
      fetchPendingWorkRequests(); // Refresh list
    } catch (err) {
      toast.error('Failed to update request status');
    }
  };

  const punchOut = async () => {
    const now = new Date();
    const eightPM = new Date();
    eightPM.setHours(20, 0, 0, 0);

    // Optional: Early punch-out confirmation
    if (now < eightPM) {
      const confirmEarly = window.confirm("⏰ Are you sure you want to punch out before 8 PM?");
      if (!confirmEarly) return;
    }

    const formatHours = (hours) => {
      const h = Math.floor(hours);
      const m = Math.round((hours - h) * 60);
      return `${h}h ${m}m`;
    };

    try {
      const response = await api.post('/attendance/punch-out', {
        employee_id: selectedEmployee.id
      });
      const data = response.data.data;

      // Update local attendance list
      setAttendanceList(prev => {
        const existingIndex = prev.findIndex(
          a => a.employee_id === selectedEmployee.id && a.date === data.date
        );
        if (existingIndex >= 0) {
          const updated = [...prev];
          updated[existingIndex] = { ...updated[existingIndex], ...data };
          return updated;
        } else {
          return [...prev, { ...data, employee_id: selectedEmployee.id }];
        }
      });

      // Toast messages based on backend-calculated status
      if (data.status === 'extra_work') {
        toast.info(`Extra work hours: ${formatHours(data.extra_work_hours)}`);
      } /*else if (data.overtime_hours > 0) {
        toast.info(`Overtime hours: ${formatHours(data.overtime_hours)}`);
      }*/

      toast.success(
        `Punch Out successful! Total Worked: ${formatHours(data.work_hours)} | Total: ${formatHours(data.total_hours)}`
      );

      // Refresh attendance list (optional)
      const today = new Date();
      const from = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split("T")[0];
      const to = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split("T")[0];
      await fetchAttendanceByRange(selectedEmployee.id, from, to);

    } catch (err) {
      console.error("PunchOut Error Details:", err.response?.data || err.message);
      toast.error(err?.response?.data?.message || 'Punch Out failed or already done.');
    }
  };


  const breakIn = async () => {
    try {
      await api.post('/attendance/break-in', { employee_id: selectedEmployee.id });
      const currentDate = new Date();
      const from = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toISOString().split("T")[0];
      const to = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).toISOString().split("T")[0];
      fetchAttendanceByRange(selectedEmployee.id, from, to);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Break In already done or failed.');
    }
  };

  const breakOut = async () => {
    try {
      await api.post('/attendance/break-out', { employee_id: selectedEmployee.id });
      toast.success('Break Out successful!');
      const currentDate = new Date();
      const from = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toISOString().split("T")[0];
      const to = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).toISOString().split("T")[0];
      fetchAttendanceByRange(selectedEmployee.id, from, to);
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Break Out already done or failed.');
    }
  };

  // Format time function
  const formatTime = (timeStr) => {
    if (!timeStr) return '-';

    // Handle HH:MM:SS format from backend (e.g., "09:39:13")
    if (typeof timeStr === 'string' && /^\d{2}:\d{2}:\d{2}$/.test(timeStr)) {
      return timeStr.substring(0, 5); // Extract just HH:MM
    }

    // Handle HH:MM format
    if (typeof timeStr === 'string' && /^\d{2}:\d{2}$/.test(timeStr)) {
      return timeStr;
    }

    return '-';
  };


  const getBreakPairs = (record) => {
    const breaks = Array.isArray(record.breaks) ? record.breaks : [];
    if (!breaks.length) return '-';
    const formatPair = (b) => `${formatTime(b.break_in)} - ${formatTime(b.break_out)}`;
    if (breaks.length <= 2) return breaks.map(formatPair).join(', ');
    const visibleBreaks = breaks.slice(0, 2);
    const hiddenBreaks = breaks.slice(2);
    const tooltip = hiddenBreaks.map(formatPair).join(', ');
    return <>{visibleBreaks.map(formatPair).join(', ')}<span className="tooltip-dots" title={tooltip}> ...</span></>;
  };

  const openRegularizationForm = (record) => {
    setSelectedDateForCorrection(record.date);
    setShowRegularizeForm(true);
  };

  const submitRegularization = async () => {
    try {
      await api.post('/attendance/regularize', {
        employee_id: selectedEmployee.id,
        date: selectedDateForCorrection,
        requested_check_in: manualCheckIn,
        requested_check_out: manualCheckOut,
        reason: reason,
        status: "present", //  required field (can be "absent", "leave", "half_day")
      },);

      toast.success('Regularization request submitted');
      setShowRegularizeForm(false);
      const today = new Date();
      const from = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split("T")[0];
      const to = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split("T")[0];
      fetchAttendanceByRange(selectedEmployee.id, from, to);
    } catch (err) {
      toast.error('Failed to submit regularization.');
    }
  };

  const renderActionButton = (record) => {

    if (role?.trim().toLowerCase() === 'hr') return <span className="text-muted">N/A</span>;
    const today = new Date();
    const todayStr = new Date().toISOString().split('T')[0]; // '2025-07-31'
    const recordDate = record.date;
    const isRegularized = record.regularize_status === 'requested' || record.regularize_status === 'approved';

    if (recordDate !== todayStr) {
      return (
        <div className="action-buttons d-flex flex-column align-items-center gap-1">
          <span className="badge bg-secondary">No Action</span>
          {record.total_hours && parseFloat(record.total_hours) < 8 && !isRegularized && (
            <button className="btn btn-sm btn-outline-primary" onClick={() => openRegularizationForm(record)}>
              Request
            </button>
          )}
        </div>
      );
    }


    if (!record.check_in) {

      return <button className="btn btn-sm btn-success" onClick={punchIn}><MdLogin /> Punch In</button>;
    }

    const breaks = Array.isArray(record.breaks) ? record.breaks : [];
    const hasOpenBreak = breaks.some((b) => b.break_in && !b.break_out);

    if (record.check_in && !record.check_out) {
      return (
        <div className="d-flex flex-column gap-2">
          {hasOpenBreak ? (
            <button className="btn btn-sm btn-info" onClick={breakOut}><MdFreeBreakfast /> Break Out</button>
          ) : (
            <button className="btn btn-sm btn-warning" onClick={breakIn}><MdFreeBreakfast /> Break In</button>
          )}
          <button className="btn btn-sm btn-danger" onClick={punchOut}><MdLogout /> Punch Out</button>
        </div>
      );
    }

    return <span className="badge bg-success">Done</span>;
  };

  //call this api when hr approved  regularization request
  const handleRequestAction = async (attendanceId, status) => {
    try {
      await api.post(`/attendance/regularize/${attendanceId}/approve`, { status });

      toast.success(`Request ${status} successfully!`);

      const res = await api.get('/attendance/regularization-requests');
      setPendingRequests(res.data);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Action failed');
    }
  };


  //to represent calender
  const getStatusDot = (status, tooltipContent) => {
    const colorMap = {
      present: "green",
      absent: "red",
      leave_applied: "yellow",
      leave_approved: "blue",
      //holiday: "purple",
      weekly_off: "gray",
      half_day_morning: "orange",
      half_day_afternoon: "pink",
    };

    if (!status) return null;

    return (
      <div className="calendar-dot-container">
        <span className={`dot ${colorMap[status]}`} />
        {tooltipContent && (
          <div className="custom-tooltip">
            {tooltipContent}
          </div>
        )}
      </div>
    );
  };

  // Fix the isWeeklyOff function
  const isWeeklyOff = (date) => {
    const day = date.getDay();
    if (day === 0) return true; // Sunday

    if (day === 6) { // Saturday
      const weekOfMonth = Math.ceil(date.getDate() / 7);
      return (weekOfMonth === 2 || weekOfMonth === 4); // 2nd & 4th off
    }
    return false;
  };


  //logic for holidays
  const fetchHolidaysForMonth = async (month, year) => {
    try {
      const res = await api.get('/holidays', { params: { month, year } });

      if (Array.isArray(res.data)) {
        // Normalize all holiday dates before setting state
        const normalizedHolidays = res.data.map(h => ({
          ...h,
          date: normalizeDate(h.date)
        }));
        setCalendarHolidays(normalizedHolidays);
        return normalizedHolidays;
      }
    } catch (error) {
      console.error("Failed to fetch holidays", error);
      setCalendarHolidays([]);
      return [];
    }
  };


  const isBackendHoliday = (date) => {
    const dateStr = normalizeDate(date);
    return calendarHolidays.some(h => {
      const holidayDate = normalizeDate(h.date);
      return holidayDate === dateStr && h.type === 'holiday';
    });
  };


  useEffect(() => {
    console.log("🔍 HR Calendar Holidays: ", calendarHolidays);
  }, [calendarHolidays]);


  const saveHoliday = async () => {
    try {
      // Save holiday
      const response = selectedHoliday.id
        ? await api.put(`/holidays/${selectedHoliday.id}`, selectedHoliday)
        : await api.post('/holidays', selectedHoliday);

      toast.success(`Holiday ${selectedHoliday.id ? 'updated' : 'added'} successfully!`);
      setShowHolidayForm(false);

      // Force refresh all relevant data
      const dateObj = new Date(selectedHoliday.date);
      const month = dateObj.getMonth() + 1;
      const year = dateObj.getFullYear();

      // 1. Refresh current view's holidays
      const updatedHolidays = await fetchHolidaysForMonth(month, year);

      // 2. If viewing a different month, refresh that too
      const today = new Date();
      if (month !== today.getMonth() + 1 || year !== today.getFullYear()) {
        await fetchHolidaysForMonth(today.getMonth() + 1, today.getFullYear());
      }

      // 3. Force calendar re-render by updating the key
      setCalendarKey(prev => prev + 1);

    } catch (err) {
      console.error(err);
      toast.error("Failed to save holiday");
    }
  };

  const deleteHoliday = async () => {
    if (!selectedHoliday?.id) return;

    if (window.confirm("Are you sure you want to delete this holiday?")) {
      try {
        await api.delete(`/holidays/${selectedHoliday.id}`);
        toast.success("Holiday deleted successfully!");
        setShowHolidayForm(false);
        const dateObj = new Date(selectedHoliday.date);
        fetchHolidaysForMonth(dateObj.getMonth() + 1, dateObj.getFullYear());
      } catch (err) {
        console.error(err);
        toast.error("Failed to delete holiday");
      }
    }
  };

  // Overall summary of whole month data 

  // In your fetchMonthlySummary function:
  const fetchMonthlySummary = async (employeeId, month, year) => {
    try {
      const res = await api.get('/monthly-summary', {
        params: { employee_id: employeeId, month, year, debug: 1 }
      });
      if (res.data && res.data.summary) {
        setMonthlyData({
          summary: res.data.summary,
          days: {
            absent_dates: res.data.absent_dates || [],
            leave_dates: res.data.counted_leave_dates || [],
            holiday_dates: res.data.holiday_dates || [],
            weekly_off_dates: res.data.weekly_off_dates || [],
            working_day_dates: res.data.working_day_dates || [],
            present_dates: res.data.present_dates || [],
            approved_leave_dates_source: res.data.approved_leave_dates_source || []
          }
        });
        console.log("SUMMARY DEBUG", res.data);

      } else {
        setMonthlyData({
          summary: {
            absent: 0,
            on_leave: 0,
            half_days: 0,
            late_joinings: 0,
            early_outs: 0,
            deficit_hours: 0,
            total_working_days: 0,
            avg_hours: 0,
            total_hours: 0
          },
          days: {}
        });
      }
    } catch (err) {
      console.error("Failed to load monthly summary", err);
      toast.error('Failed to load monthly summary');
      setMonthlyData({ summary: null, days: {} });
    }
  };

  //call when moth /year changes...
  useEffect(() => {
    if (selectedEmployee?.id) {
      fetchMonthlySummary(selectedEmployee.id, currentMonth, currentYear);
    }
  }, [selectedEmployee, currentMonth, currentYear]);


  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get("/public-holidays", { params: { year: 2025 } });
        setPublicHolidays(res.data);
      } catch (err) {
        console.error("Holiday fetch failed", err);
      }
    };
    fetch();
  }, [token]);

  const getHolidayForDate = (date) => {
    const dateStr = normalizeDate(date);
    return calendarHolidays.find(h => normalizeDate(h.date) === dateStr && h.type === 'holiday');
  };

  const handleHolidayClick = (holiday) => {
    setSelectedHoliday(holiday);
    setShowHolidayForm(true);
  };

  // employee holiday handle clik function
  const handleEmployeeHolidayClick = (date) => {
    const actualDate = (typeof date === 'string') ? new Date(date) : date;

    if (isBackendHoliday(actualDate) || isWeeklyOff(actualDate)) {
      setSelectedWorkDate(normalizeDate(actualDate));
      setShowWorkRequestModal(true);
    } else {
      toast.info("This date is not a holiday or weekly off.");
    }
  };

  const getCalendarStatus = (date) => {
    const dateStr = normalizeDate(date);
    console.groupCollapsed(`Status check for ${dateStr}`);

    if (!dateStr) {
      console.log('Invalid date');
      console.groupEnd();
      return null;
    }

    // 1. Check if it's a holiday first
    const holiday = calendarHolidays.find(h => normalizeDate(h.date) === dateStr);
    if (holiday) {
      console.log('Holiday match:', holiday);
      console.groupEnd();
      return holiday.type === 'weekly_off' ? 'weekly_off' : 'holiday';
    }

    // 2. Check if it's a weekly off day
    if (isWeeklyOff(date)) {
      console.log('Weekly off day');
      console.groupEnd();
      return 'weekly_off';
    }

    // 3. Check for approved leaves
    const leave = leaveList.find(l => {
      const start = normalizeDate(l.start_date);
      const end = normalizeDate(l.end_date);
      return dateStr >= start && dateStr <= end &&
        l.employee_id === selectedEmployee?.id &&
        l.status === 'approved';
    });

    if (leave) {
      console.log('Approved leave found');
      console.groupEnd();
      return 'leave_approved';
    }

    // 4. Check for pending leaves
    const pendingLeave = leaveList.find(l => {
      const start = normalizeDate(l.start_date);
      const end = normalizeDate(l.end_date);
      return dateStr >= start && dateStr <= end &&
        l.employee_id === selectedEmployee?.id;
    });

    if (pendingLeave) {
      console.log('Pending leave found');
      console.groupEnd();
      return 'leave_applied';
    }

    // 5. Check attendance records
    const record = attendanceList.find(a =>
      normalizeDate(a.date) === dateStr &&
      a.employee_id === selectedEmployee?.id
    );

    if (record) {
      console.log('Attendance record found:', record);
      if (record.status === 'present') {
        if (record.day_type === 'half') {
          console.groupEnd();
          return record.check_in && !record.check_out ? 'half_day_afternoon' : 'half_day_morning';
        }
        console.groupEnd();
        return 'present';
      }
      console.groupEnd();
      return 'absent'; // Explicit absent status from record
    }

    // 6. If no record exists for a past working day, mark as absent
    const today = new Date();
    const currentDate = new Date(dateStr);
    if (currentDate < today && !isWeeklyOff(date) && !holiday) {
      console.log('No record for past working day - marking as absent');
      console.groupEnd();
      return 'absent';
    }

    console.log('No status determined');
    console.groupEnd();
    return null;
  };
  //useeffct for calender 
  useEffect(() => {
    if (!selectedEmployee?.id) return;

    const loadCalendarData = async () => {
      try {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();

        // Fetch all data in parallel
        const [holidays, leaves, attendance] = await Promise.all([
          fetchHolidaysForMonth(month, year),
          fetchMonthlyLeaves(selectedEmployee.id, month, year),
          fetchAttendanceByRange(selectedEmployee.id,
            new Date(year, month - 4, 1).toISOString().split('T')[0],
            new Date(year, month + 1, 0).toISOString().split('T')[0]
          )
        ]);

        console.log("Loaded holidays:", holidays);

      } catch (err) {
        console.error('Calendar data loading failed:', err);
        toast.error('Failed to load calendar data');
      }
    };

    loadCalendarData();
  }, [selectedEmployee?.id]);

  //today's record 

  const today = new Date();
  const todayStr = today.toISOString().split('T')[0]; // "YYYY-MM-DD"

  const calendarDates = [];

  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    calendarDates.push(new Date(d));
  }


  // Then update your todayRecord finding logic:
  const todayRecord = useMemo(() => {
    return attendanceList.find(record => {
      const recordDate = new Date(record.date).toISOString().split('T')[0];
      return (
        record.employee_id === selectedEmployee?.id &&
        recordDate === todayStr
      );
    });
  }, [attendanceList, selectedEmployee?.id, todayStr]);

  // Normalize function
  const normalizeDate = (dateInput) => {
    if (!dateInput) return null;

    try {
      if (dateInput instanceof Date) {
        const pad = num => num.toString().padStart(2, '0');
        return `${dateInput.getFullYear()}-${pad(dateInput.getMonth() + 1)}-${pad(dateInput.getDate())}`;
      }

      if (typeof dateInput === 'string') {
        const [y, m, d] = dateInput.split('-').map(Number);
        if (!y || !m || !d) return null;
        return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      }

      return null;
    } catch (e) {
      console.error('Date normalization error:', e, 'Input:', dateInput);
      return null;
    }
  };

  const pastRecords = attendanceList
    .filter(record => {
      const recordDate = normalizeDate(record.date);
      const today = normalizeDate(new Date());
      return (
        record.employee_id === selectedEmployee?.id &&
        recordDate &&
        recordDate !== today
      );
    })
    .sort((a, b) => new Date(b.date) - new Date(a.date)); // new dates comes first

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = pastRecords.slice(indexOfFirstRecord, indexOfLastRecord);



  // hr records pagination
  const hrIndexOfLastRecord = hrCurrentPage * hrRecordsPerPage;
  const hrIndexOfFirstRecord = hrIndexOfLastRecord - hrRecordsPerPage;
  const hrSortedRecords = [...attendanceList].sort((a, b) => new Date(b.date) - new Date(a.date));
  const hrPaginatedRecords = hrSortedRecords.slice(hrIndexOfFirstRecord, hrIndexOfLastRecord);


  //Main Jsx part of code starts here 

  return (
    <div className="tab-wrapper py-4">

      {loading && (
        <div className="global-loader-overlay">
          <div className="spinner" />
        </div>
      )}

      <ToastContainer position="top-center" autoClose={3000} />

      {/* Regularization Modal */}
      {showRegularizeForm && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h5>Regularize for {selectedDateForCorrection}</h5>
            <label>Requested Check In:</label>
            <input type="time" value={manualCheckIn} onChange={(e) => setManualCheckIn(e.target.value)} />
            <label>Requested Check Out:</label>
            <input type="time" value={manualCheckOut} onChange={(e) => setManualCheckOut(e.target.value)} />
            <label>Reason:</label>
            <textarea value={reason} onChange={(e) => setReason(e.target.value)} />
            <div className="mt-2">
              <button className="btn btn-primary" onClick={submitRegularization}>Submit</button>
              <button className="btn btn-secondary ms-2" onClick={() => setShowRegularizeForm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="row g-3">
        {/* ✅ EMPLOYEE VIEW ONLY */}
        {role?.trim().toLowerCase() !== 'hr' && (
          <>
            {/* Left Side: Today's Attendance */}
            <div className="col-md-4">
              {selectedEmployee && (

                <div className="card shadow rounded-4 todays-attendance-card">
                  <div className="card-header text-white text-center rounded-top-4">
                    <h5>Today's Attendance</h5>
                  </div>
                  <div className="card-body">
                    {console.log("Raw check-in time from backend:", todayRecord?.check_in)}
                    {console.log("Formatted check-in time:", formatTime(todayRecord?.check_in))}
                    <table className="table table-bordered">
                      <tbody>
                        <tr><td><strong>Name:</strong></td><td>{selectedEmployee?.name || '-'}</td></tr>
                        <tr><td><strong>Date:</strong></td><td>{todayRecord?.date ? new Date(todayRecord.date).toISOString().split('T')[0] : todayStr}</td></tr>
                        <tr>
                          <td><strong>Check-In:</strong></td>
                          <td>
                            {todayRecord?.check_in ? (
                              <span>{formatTime(todayRecord.check_in)}</span>
                            ) : (
                              <span className="text-danger">Not checked in yet</span>
                            )}
                          </td>
                        </tr>
                        <tr><td><strong>Breaks:</strong></td><td>{todayRecord ? getBreakPairs(todayRecord) : '-'}</td></tr>
                        <tr><td><strong>Check-Out:</strong></td><td>{todayRecord?.check_out ? formatTime(todayRecord.check_out) : '-'}</td></tr>
                        <tr><td><strong>Total Hours:</strong></td><td>{todayRecord?.total_hours || '-'}</td></tr>
                        <tr>
                          <td colSpan={2}>
                            {todayRecord ? renderActionButton(todayRecord) : (
                              <button className="btn btn-sm btn-success" onClick={punchIn}>
                                <MdLogin /> Punch In
                              </button>

                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {/* Right Side: Attendance Logs */}
            <div className="col-md-4">
              <div className="card shadow rounded-4">
                <div className="card-header text-center text-white rounded-top-4">
                  <h5>Attendance Logs</h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Check In</th>
                          <th>Breaks</th>
                          <th>Check Out</th>
                          <th>Total Hours</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.map((record) => (
                          <tr key={record.id}>
                            <td>{record.date}</td>
                            <td>{formatTime(record.check_in)}</td>
                            <td>{getBreakPairs(record)}</td>
                            <td>{formatTime(record.check_out)}</td>
                            <td>{record.total_hours || '-'}</td>
                            <td>
                              {record.status === 'extra_work' ? (
                                <span className="badge bg-primary" title={`${record.extra_work_hours} hrs`}>
                                  Extra Work
                                </span>
                              ) : record.overtime_hours > 0 ? (
                                <span className="badge bg-warning text-dark" title={`${record.overtime_hours} hrs`}>
                                  Overtime
                                </span>
                              ) : isBackendHoliday(record.date) ? (
                                <span className="badge bg-info">Holiday</span>
                              ) : record.regularize_status === 'requested' ? (
                                <span className="badge bg-warning">Requested</span>
                              ) : record.regularize_status === 'approved' ? (
                                <span className="badge bg-success">Approved</span>
                              ) : record.regularize_status === 'rejected' ? (
                                <span className="badge bg-danger">Rejected</span>
                              ) : (
                                <span className="text-muted">{record.status || '-'}</span>
                              )}
                            </td>
                            <td>{renderActionButton(record)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="pagination-container mt-3">
                    {[...Array(Math.ceil(pastRecords.length / recordsPerPage)).keys()].map((num) => (
                      <button
                        key={num}
                        onClick={() => setCurrentPage(num + 1)}
                        className={`pagination-btn ${currentPage === num + 1 ? 'active' : ''}`}
                      >
                        {num + 1}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Calendar View Section - Right aligned under Attendance Logs */}
            <div className="col-md-4">
              <div className="card calendar-card shadow rounded-4">
                <div className="card-header text-white bg-info">
                  Calendar View
                </div>
                <div className="card-body">
                  <div className="calendar-container">
                    <div className="react-calendar-wrapper">
                      {selectedEmployee && (
                        <Calendar
                          formatShortWeekday={(locale, date) =>
                            ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()]
                          }
                          key={`${calendarHolidays.length}-${leaveList.length}-${attendanceList.length}`}

                          onClickDay={(value) => {

                            const month = value.getMonth() + 1;
                            const year = value.getFullYear();
                            const selected = normalizeDate(value);
                            const userRole = (role || "").trim().toLowerCase();
                            if (isHR) {
                              const holiday = getHolidayForDate(value);
                              handleHolidayClick(holiday || { date: selected });
                            }
                            else {
                              setSelectedDateForLeave(selected);
                              setShowLeaveForm(true);
                              handleEmployeeHolidayClick(selected);
                            }
                          }}

                          activeStartDate={activeStartDate}
                          onActiveStartDateChange={({ activeStartDate }) => {
                            setActiveStartDate(activeStartDate);
                            const month = activeStartDate.getMonth() + 1;
                            const year = activeStartDate.getFullYear();

                            // Always fetch holidays for month/year
                            fetchHolidaysForMonth(month, year);

                            const from = new Date(year, month - 1, 1).toISOString().split('T')[0];
                            const to = new Date(year, month, 0).toISOString().split('T')[0];

                            const prevMonth = month === 1 ? 12 : month - 1;
                            const prevYear = month === 1 ? year - 1 : year;

                            const empId = isHR ? selectedEmployee?.id : employeeData.id;
                            if (empId) {

                              Promise.all([
                                fetchMonthlyLeaves(empId, month, year),
                                fetchMonthlyLeaves(empId, prevMonth, prevYear),
                                fetchAttendanceByRange(empId, from, to)
                              ]).catch(err => {
                                console.error("Error loading calendar data:", err);
                                toast.error("Failed to update calendar data");
                              });
                            }
                          }}


                          tileClassName={({ date }) => {
                            const isSunday = date.getDay() === 0;
                            const isHoliday = isBackendHoliday(date);
                            if (isHoliday || isSunday) return 'only-sunday-red';
                            return null;
                          }}

                          tileContent={({ date, view }) => {
                            if (view !== 'month') return null;
                            const dateStr = normalizeDate(date);

                            const dayData = monthlyData?.days?.[dateStr]; // Safe access

                            // Debugging - compare calendar logic with backend logic
                            console.log('Day analysis:', {
                              date: dateStr,
                              backendStatus: dayData?.status,
                              calendarStatus: getCalendarStatus(date),
                              isSame: dayData?.status === getCalendarStatus(date)
                            });

                            const todayStr = normalizeDate(new Date());

                            const holiday = getHolidayForDate(date);
                            const isHoliday = !!holiday;
                            if (dateStr > todayStr) {
                              // display only if it is holiday
                              if (!isHoliday) return null;
                              return getStatusDot('holiday', (
                                <>
                                  <div><strong>Date:</strong> {dateStr}</div>
                                  <div><strong>Holiday Name:</strong> {holiday.name}</div>
                                  {holiday.reason && <div><strong>Reason:</strong> {holiday.reason}</div>}
                                </>
                              ));
                            }

                            const status = getCalendarStatus(date);
                            const isWeekOff = isWeeklyOff(date);
                            const attendance = attendanceList.find(
                              (rec) => normalizeDate(rec.date) === dateStr && rec.employee_id === selectedEmployee?.id
                            );
                            const leaveStatus = getLeaveStatusForDate(normalizeDate(date));
                            const breaks = attendance?.breaks || [];

                            const formatTime = (timeStr) => {
                              if (!timeStr) return '-';
                              const date = new Date(`1970-01-01T${timeStr}`);
                              return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                            };

                            const handleClick = () => {
                              if (isHR) {
                                handleHolidayClick(holiday || { date: dateStr });
                              } else {
                                setSelectedDateForLeave(dateStr);
                                setShowLeaveForm(true);
                                handleEmployeeHolidayClick(dateStr);
                              }
                            };

                            const tooltipContent = (
                              <>
                                <div><strong>Date:</strong> {dateStr}</div>
                                <div><strong>Employee:</strong> {selectedEmployee?.name || '-'}</div>
                                <div><strong>Status:</strong> {status}</div>
                                <div><strong>Leave:</strong> {leaveStatus || 'None'}</div>
                                <div><strong>Holiday:</strong> {isHoliday ? 'Yes' : 'No'}</div>
                                {holiday && (
                                  <>
                                    <div><strong>Holiday Name:</strong> {holiday.name}</div>
                                    {holiday.reason && <div><strong>Reason:</strong> {holiday.reason}</div>}
                                  </>
                                )}
                                <div><strong>Weekly Off:</strong> {isWeekOff ? 'Yes' : 'No'}</div>
                                <div><strong>Check-In:</strong> {formatTime(attendance?.check_in)}</div>
                                <div><strong>Check-Out:</strong> {formatTime(attendance?.check_out)}</div>
                                <div><strong>Breaks:</strong></div>
                                {breaks.length > 0 ? (
                                  <ul>
                                    {breaks.map((b, i) => (
                                      <li key={i}>{formatTime(b.break_in)} - {formatTime(b.break_out)}</li>
                                    ))}
                                  </ul>
                                ) : (
                                  <div>None</div>
                                )}

                              </>
                            );

                            console.log('Debug date:', dateStr, {
                              status,
                              isHoliday,
                              isWeekOff,
                              leaveStatus,
                              attendance
                            });

                            return (
                              <div
                                className={`calendar-date-wrapper ${isHoliday || isWeekOff ? 'holiday' : ''}`}
                                onClick={handleClick}
                              >
                                {getStatusDot(status, tooltipContent)}
                              </div>
                            );

                          }}
                        />
                      )}

                    </div>

                  </div>

                </div>

                {showLeaveForm && (
                  <div className="modal-overlay">
                    <div className="modal-box">
                      <h5>Apply Leave for {selectedDateForLeave}</h5>

                      <label>Leave Type:</label>
                      <select value={leaveType} onChange={(e) => setLeaveType(e.target.value)}>
                        <option value="full">Full Day</option>
                        <option value="half">Half Day</option>
                      </select>

                      {leaveType === 'half' && (
                        <>
                          <label>Half Day Type:</label>
                          <select value={halfDayType} onChange={(e) => setHalfDayType(e.target.value)}>
                            <option value="morning">Morning</option>
                            <option value="afternoon">Afternoon</option>
                          </select>
                        </>
                      )}

                      <label>Reason:</label>
                      <textarea
                        className="form-control"
                        value={leaveReason}
                        onChange={(e) => setLeaveReason(e.target.value)}
                      />

                      <div className="mt-2">
                        <button className="btn btn-primary" onClick={submitLeaveRequest}>Submit</button>
                        <button className="btn btn-secondary ms-2" onClick={() => setShowLeaveForm(false)}>Cancel</button>
                      </div>
                    </div>
                  </div>

                )}

                {showWorkRequestModal && (
                  <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="workRequestModal" aria-modal="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Request to Work on {selectedWorkDate}</h5>
                          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowWorkRequestModal(false)}></button>
                        </div>
                        <div className="modal-body">
                          <div className="mb-3">
                            <label htmlFor="workType" className="form-label">Select Work Type</label>
                            <select
                              id="workType"
                              className="form-select"
                              value={selectedWorkType}
                              onChange={e => setSelectedWorkType(e.target.value)}
                            >
                              <option value="full">Full Day</option>
                              <option value="half">Half Day</option>
                            </select>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary" onClick={() => setShowWorkRequestModal(false)}>Cancel</button>
                          <button type="button" className="btn btn-primary" onClick={submitWorkRequest}>Submit Request</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="calendar-legend px-3 pb-3">
                  <span className="legend-item"><span className="dot green" /> Present</span>
                  <span className="legend-item"><span className="dot red" /> Absent</span>
                  <span className="legend-item"><span className="dot yellow" /> Leave Applied</span>
                  <span className="legend-item"><span className="dot blue" /> Leave Approved</span>
                  <span className="legend-item"><span className="dot gray" /> Weekly Off</span>
                  <div><span className="dot orange"></span> Half-Day Morning</div>
                  <div><span className="dot pink"></span> Half-Day Afternoon</div>
                </div>
              </div>
            </div>

            {/* Monthly Summary Bar - Added above Calendar */}
            {/* Combined Monthly Summary and Holiday List Section */}
            <div className="row">
              {/* Monthly Summary - Takes 8 columns */}
              <div className="col-md-8 pe-3"> {/* Added pe-3 for right padding */}
                {selectedEmployee && (
                  <>
                    {monthlyData.summary && (
                      <div className="monthly-summary-bar">
                        <div className="summary-header d-flex justify-content-between align-items-center mb-2">
                          <h5 className="mb-0">
                            {new Date(currentYear, currentMonth - 1).toLocaleString("default", {
                              month: "long",
                              year: "numeric",
                            })}{" "}
                            Summary
                          </h5>
                          <div className="month-selector">
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => {
                                const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;
                                const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
                                setCurrentMonth(prevMonth);
                                setCurrentYear(prevYear);
                                setActiveStartDate(new Date(prevYear, prevMonth - 1, 1));
                              }}
                            >
                              &lt;
                            </button>
                            <span className="mx-2">
                              {new Date(currentYear, currentMonth - 1).toLocaleString(
                                "default",
                                { month: "long" }
                              )}
                            </span>
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => {
                                const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
                                const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;
                                setCurrentMonth(nextMonth);
                                setCurrentYear(nextYear);
                                setActiveStartDate(new Date(nextYear, nextMonth - 1, 1));
                              }}
                            /*disabled={currentMonth === new Date().getMonth() + 1 && currentYear === new Date().getFullYear()}*/
                            >
                              &gt;
                            </button>
                          </div>
                        </div>

                        <div className="summary-grid">
                          <div className="summary-card absent">
                            <div className="icon">🚫</div>
                            <div className="value">{monthlyData.summary.absent}</div>
                            <div className="label">Absent</div>
                          </div>

                          <div className="summary-card leave">
                            <div className="icon">🏖️</div>
                            <div className="value">{monthlyData.summary.on_leave}</div>
                            <div className="label">On Leave</div>
                          </div>

                          <div className="summary-card half-day">
                            <div className="icon">½</div>
                            <div className="value">{monthlyData.summary.half_days}</div>
                            <div className="label">Half Days</div>
                          </div>

                          <div className="summary-card late">
                            <div className="icon">⏰</div>
                            <div className="value">{monthlyData.summary.late_joinings}</div>
                            <div className="label">Late In</div>
                          </div>

                          <div className="summary-card early-out">
                            <div className="icon">🏃</div>
                            <div className="value">{monthlyData.summary.early_outs}</div>
                            <div className="label">Early Out</div>
                          </div>

                          <div className="summary-card deficit">
                            <div className="icon">⚠️</div>
                            <div className="value">{monthlyData.summary.deficit_hours}h</div>
                            <div className="label">
                              Deficit <span className="small-text text-muted" title="Deficit calculated till today, excluding approved leaves & holidays">(till today)</span>
                            </div>
                          </div>


                          <div className="summary-card working-days">
                            <div className="icon">📅</div>
                            <div className="value">{monthlyData.summary.total_working_days}</div>
                            <div className="label">Working Days</div>
                          </div>

                          <div className="summary-card avg-hours">
                            <div className="icon">⏱️</div>
                            <div className="value">{monthlyData.summary.avg_hours}h</div>
                            <div className="label">Avg Hours</div>
                          </div>

                          <div className="summary-card total-hours">
                            <div className="icon">🕒</div>
                            <div className="value">{monthlyData.summary.total_hours}h</div>
                            <div className="label">Total Hours</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Holiday List - Takes 4 columns */}
              <div className="col-md-4 ps-2"> {/* Added ps-2 for left padding */}
                <div className="holiday-card h-100"> {/* Added h-100 for full height */}
                  <div className="holiday-card-header">
                    <h3 style={{ fontSize: "16px", fontWeight: "600", margin: 0 }}>📅 Holidays</h3>
                    <span>{new Date().getFullYear()}</span>
                  </div>
                  <div className="holiday-card-body">
                    {publicHolidays.map((h, i) => (
                      <div key={i} className="holiday-item">
                        <div className={`holiday-date color-${(i % 6) + 1}`}>
                          <div className="day">{h.day}</div>
                          <div className="month">{h.month}</div>
                        </div>
                        <div className="holiday-info">
                          <div className="holiday-title">{h.title}</div>
                          <div className="holiday-weekday">{h.weekday}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* ✅ HR VIEW ONLY */}
        {role?.trim().toLowerCase() === 'hr' && (
          <div className="col-md-12">
            <div className="card shadow rounded-4">
              <div className="card-header text-white text-center rounded-top-4 bg-dark">
                <h5>All Employees' Attendance Logs</h5>
              </div>
              <div className="card-body table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Date</th>
                      <th>Check In</th>
                      <th>Breaks</th>
                      <th>Check Out</th>
                      <th>Total Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hrPaginatedRecords.map((record) => (
                      <tr key={record.id}>
                        <td>{record.employee?.name || '-'}</td>
                        <td>{record.date}</td>
                        <td>{formatTime(record.check_in)}</td>
                        <td>{getBreakPairs(record)}</td>
                        <td>{formatTime(record.check_out)}</td>
                        <td>{record.total_hours || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* HR Pagination */}
                <div className="pagination-container mt-3">
                  {[...Array(Math.ceil(attendanceList.length / hrRecordsPerPage)).keys()].map((num) => (
                    <button
                      key={num}
                      onClick={() => setHrCurrentPage(num + 1)}
                      className={`pagination-btn ${hrCurrentPage === num + 1 ? 'active' : ''}`}
                    >
                      {num + 1}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* HR: Regularization Requests */}
            <div className="card shadow mt-4 rounded-4 pending-regularization-card">
              <div className="card-header text-white text-center rounded-top-4 bg-primary">
                <h5>Pending Attendance Regularization Requests</h5>
              </div>
              <div className="card-body table-responsive">
                {pendingRequests.length === 0 ? (
                  <p className="text-center">No pending requests 🎉</p>
                ) : (
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Date</th>
                        <th>Requested Check In</th>
                        <th>Requested Check Out</th>
                        <th>Reason</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingRequests.map((req) => (
                        <tr key={req.id}>
                          <td>{req.employee?.name}</td>
                          <td>{req.date}</td>
                          <td>{req.requested_check_in}</td>
                          <td>{req.requested_check_out}</td>
                          <td>{req.reason}</td>
                          <td>
                            <button className="btn btn-sm btn-success btn-approve me-2" onClick={() => handleRequestAction(req.id, 'approved')}>Approve</button>
                            <button className="btn btn-sm btn-danger btn-reject" onClick={() => handleRequestAction(req.id, 'rejected')}>Reject</button>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            {/* HR: Work-On-Holiday Requests */}
            <div className="card pending-requests-card shadow mt-4 rounded-4">
              <div className="card-header text-white text-center rounded-top-4 bg-warning">
                <h5>Pending Work-On-Holiday Requests</h5>
              </div>
              <div className="card-body table-responsive">
                {pendingWorkRequests.length === 0 ? (
                  <p className="text-center">No pending requests 🎉</p>
                ) : (
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Date</th>
                        <th>Work Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingWorkRequests.map((req) => (
                        <tr key={req.id}>
                          <td>{req.employee?.name || 'Unknown Employee'}</td>
                          <td>{req.date}</td>
                          <td>{req.work_type}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-success me-2"
                              onClick={() => updateRequestStatus(req.id, 'approved')}
                            >
                              Approve
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => updateRequestStatus(req.id, 'rejected')}
                            >
                              Reject
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>

            {/* HR Calendar (Common) */}
            {isHR && (
              <div className="col-md-12">
                <div className="card calendar-card shadow rounded-4">
                  <div className="card-header text-white bg-info">
                    Hr Calendar
                  </div>
                  <div className="card-body">
                    <Calendar
                      formatShortWeekday={(locale, date) =>
                        ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()]
                      }
                      key={`${calendarHolidays.length}`}
                      onClickDay={(value) => {
                        const selected = normalizeDate(value);
                        const holiday = getHolidayForDate(value);
                        handleHolidayClick(holiday || { date: selected });
                      }}
                      onActiveStartDateChange={({ activeStartDate }) => {
                        const month = activeStartDate.getMonth() + 1;
                        const year = activeStartDate.getFullYear();
                        fetchHolidaysForMonth(activeStartDate.getMonth() + 1, activeStartDate.getFullYear());
                      }}
                      tileClassName={({ date }) => {
                        const isSunday = date.getDay() === 0;
                        const isHoliday = isBackendHoliday(date);
                        if (isHoliday || isSunday) return 'only-sunday-red';
                        return null;
                      }}
                      tileContent={({ date, view }) => {
                        if (view !== 'month') return null;
                        const dateStr = normalizeDate(date);
                        const todayStr = normalizeDate(new Date());
                        const holiday = getHolidayForDate(date);
                        const isHoliday = !!holiday;

                        if (dateStr > todayStr) {
                          // display only if holiday 
                          if (!isHoliday) return null;
                          return getStatusDot('holiday', (
                            <>
                              <div><strong>Date:</strong> {dateStr}</div>
                              <div><strong>Holiday Name:</strong> {holiday.name}</div>
                              {holiday.reason && <div><strong>Reason:</strong> {holiday.reason}</div>}
                            </>
                          ));
                        }

                        const status = getCalendarStatus(date);

                        const isWeekOff = isWeeklyOff(date);

                        const tooltipContent = (
                          <>
                            <div><strong>Date:</strong> {dateStr}</div>
                            <div><strong>Status:</strong> {status}</div>
                            <div><strong>Holiday:</strong> {isHoliday ? 'Yes' : 'No'}</div>
                            {holiday && (
                              <>
                                <div><strong>Holiday Name:</strong> {holiday.name}</div>
                                {holiday.reason && <div><strong>Reason:</strong> {holiday.reason}</div>}
                              </>
                            )}
                            <div><strong>Weekly Off:</strong> {isWeekOff ? 'Yes' : 'No'}</div>
                          </>
                        );
                        return getStatusDot(status, tooltipContent);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}


            {showHolidayForm && (
              <div className="holiday-modal-overlay">
                <div className="holiday-modal">
                  <h2>{selectedHoliday?.id ? "Edit Holiday" : "Add Holiday"}</h2>

                  <label>Date:</label>
                  <input
                    type="date"
                    value={selectedHoliday.date}
                    onChange={(e) =>
                      setSelectedHoliday({ ...selectedHoliday, date: e.target.value })
                    }
                  />

                  <label>Name:</label>
                  <input
                    type="text"
                    value={selectedHoliday.name}
                    onChange={(e) =>
                      setSelectedHoliday({ ...selectedHoliday, name: e.target.value })
                    }
                  />

                  <label>Reason:</label>
                  <textarea
                    value={selectedHoliday.reason || ""}
                    onChange={(e) =>
                      setSelectedHoliday({ ...selectedHoliday, reason: e.target.value })
                    }
                  />

                  <div className="holiday-modal-buttons">
                    {selectedHoliday?.id && (
                      <button className="btn-danger" onClick={deleteHoliday}>Delete</button>
                    )}
                    <button className="btn-secondary" onClick={() => setShowHolidayForm(false)}>Cancel</button>
                    <button className="btn-primary" onClick={saveHoliday}>Save</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

      </div>

    </div>




  );

};

export default AttendanceForm;
